import { amber, red, blue, teal } from '@material-ui/core/colors';
import { Grid, Paper, Tooltip, Typography } from '@material-ui/core';
import { useCompanyMaster, useSnackbarInstance } from '@lib/common';
import { useCallback, useMemo, useState, useRef } from 'react';
import { scrollToElement, withScrollSpyItem } from '@components/scroll-spy';
import { Column } from 'react-table';
import { DraggableRowsTable } from '@components/draggable-rows-table';
import { ColoredChipIconButton } from '@components/colored-elements';
import { ImDrawer2, TrashFill, BiEdit } from '@icon/react-icons';
import { createContextQuick } from '@components/quick-context';
import { Control, useController, useFormContext } from 'react-hook-form';
// import { TypesContainer } from '../company-types';
// import { createFormField } from '../../common';
import getLoadingMessage from '@lib/common/loading-messages';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import { ContentMedia } from '@lib/company';
import styled from 'styled-components';
import { thumbStack } from '@lib/common/css';
import { ColoredAvatar, ColoredChip } from '@components/colored-elements';
import { MediaPicker } from './MediaPicker';
import { CellForCompanyServices, CellForCompanyProjects, CellForMediaName } from './utils'

export const MediaLoader = ({ value = null, onChange = null, company_services = null, isLock = null, company_vtr_id = null }) => {
  const { enqueue } = useSnackbarInstance();

  const onMediaAdd = useCallback(
    (media: ContentMedia) => {
      if (value && onChange) {

        if (media?.media_type == 'video') {
          if ((!value.find(v => v.media_url == media.media_url))) {
            onChange([...value, media]);
          } else {
            enqueue(
              <>
                {/* Media &nbsp;<strong>{`${media.file_name}`}</strong>&nbsp; is
                already added. */}
                Media with same name/url is already added
              </>,
              { variant: 'error' }
            );
          }
        }
        else {
          if ((!value.find(v => v.file_name === media.file_name))) {
            onChange([...value, media]);
          } else {
            enqueue(
              <>
                Media &nbsp;<strong>{`${media.file_name}`}</strong>&nbsp; is
                already added.
                {/* Media with same name/url is already added */}
              </>,
              { variant: 'error' }
            );
          }
        }

      } else if (!value) {
        // Adding new media and the value is not usable.
        onChange([media]);
      }
    },
    [value, onChange]
  );

  const onMediaDelete = (media: ContentMedia) => {
    if (value && onChange) {
      if (media?.media_type != 'video') {
        var idx = value.findIndex(v => (v.path === media.path && v.file_name === media.file_name));
      }
      else {
        var idx = value.findIndex(v => (v.media_url === media.media_url));
      }
      if (idx >= 0) {
        const nextValue = [...value];
        nextValue.splice(idx, 1);
        onChange(nextValue);
      }
    }
  };

  const onEditMedia = (media: ContentMedia, idx?: number) => {
    if (value && onChange) {
      if (idx >= 0) {
        const nextValue = [...value];
        nextValue[idx] = media;
        onChange(nextValue);
      }
    }
  };

  const MediaColumn: Column<ContentMedia>[] = useMemo(
    () => [
      {
        Header: '#',
        id: 'serial',
        accessor: (_row, idx) => idx + 1,
        width: 35,
      },
      {
        Header: 'Media',
        Cell: CellForMediaName,
        // accessor: row => (row?.file_name ? row?.file_name : row?.media_url),
        width: 200,
      },
      {
        Header: 'Caption',
        // Cell: CellForMediaName,
        accessor: row => (row?.media_title ? row?.media_title : 'NA'),
        width: 200,
      },
      {
        Header: 'Services',
        id: 'associated_services',
        // accessor: row => row.associated_services,
        Cell: CellForCompanyServices,
        width: 200,
      },
      {
        Header: 'Projects',
        id: 'associated_projects',
        Cell: CellForCompanyProjects,
        // accessor: row => row.associated_projects,
        width: 200,
      },
      {
        Header: 'Media Type',
        id: 'video_type',
        accessor: row => row.media_type,
        width: 200,
      },
      {
        Header: 'Media Source',
        id: 'source',
        accessor: row => row.source,
        width: 200,
      },
      // {
      //   Header: 'Image',
      //   id: 'attach_b64',
      //   accessor: row => row.attach_b64,
      //   forceHide: true,
      //   width: 200,
      // },
      {
        Header: 'Action',
        id: 'actions',
        width: 80,
        Cell({ row }) {
          const [eachMediaEdit, setEachMediaEdit] = useState(false);
          const { deleteMedia, editMedia } = useActions();
          const onDeleteClick = () => deleteMedia(row.original);
          const onEditClick = () => {
            setEachMediaEdit(true);
          };
          const editMediaFunction = (media, idx) => {
            editMedia(media, idx);
            setEachMediaEdit(false);
          };

          return (
            <>
              <Tooltip title="Edit">
                <span style={{ paddingRight: '5px' }}>
                  <ColoredChipIconButton
                    onClick={onEditClick}
                    pointer
                    colored={blue[900]}
                    size="small"
                    disabled={isLock || (row.original.source != null && row.original.source != 'Deli' && row.original.source != 'Vitrina')}
                    icon={<BiEdit />}
                  />

                  <MediaPicker
                    onMediaAdd={onMediaAdd}
                    onMediaEdit={editMediaFunction}
                    MediaEditState={eachMediaEdit}
                    editMediaScenario={true}
                    editMediaIndex={row.index}
                    editMediaData={row.original}
                    setEachMediaEdit={setEachMediaEdit}
                    company_services={company_services}
                    company_vtr_id={company_vtr_id}
                  />
                </span>
              </Tooltip>
              <Tooltip title="Delete">
                <span>
                  <ColoredChipIconButton
                    onClick={onDeleteClick}
                    pointer
                    disabled={isLock || (row.original.source != null && row.original.source != 'Deli' && row.original.source != 'Vitrina')}
                    colored={red[900]}
                    size="small"
                    icon={<TrashFill />}
                  />
                </span>
              </Tooltip>
            </>
          );
        },
      },
    ],
    [isLock]
  );
  return (
    <MediaContainer>
      <Grid container spacing={4} justify="center" alignItems="center">
        <Grid item>
          <Typography variant="h6" style={{ fontSize: 16 }}>
            Manage Company Media
          </Typography>
        </Grid>
        <Grid item xs />
        <Grid item>
          <MediaPicker onMediaAdd={onMediaAdd} company_vtr_id={company_vtr_id} company_services={company_services} isLock={isLock} />
        </Grid>
      </Grid>
      {value && value.length ? (
        <Paper className="fixed-height">
          <ProvideEdit deleteMedia={onMediaDelete} editMedia={onEditMedia}>
            <DraggableRowsTable
              getRowId={getMediaRowId}
              onChange={onChange}
              columns={MediaColumn}
              data={value}
              stickyHeader
              size="small"
              showDragIcon={true}
              sectionName={"media"}
              company_vtr_id={company_vtr_id}
            // stopDrag={true}
            />
          </ProvideEdit>
        </Paper>
      ) : (
        EmptyContent
      )}
    </MediaContainer>
  );
};

const EmptyContent = (
  <Paper className="fixed-height no-data">
    <span>
      <ImDrawer2 />
      <br />
      <Typography>
        Click on <strong>Add</strong> button
        <br />
        and start managing Media.
      </Typography>
    </span>
  </Paper>
);

const [ProvideEdit, useActions] =
  createContextQuick<{
    deleteMedia?: (media: ContentMedia) => any;
    editMedia?: (media: ContentMedia, idx?: number) => any;
  }>();

const getMediaRowId = (row, idx) => (row.file_name || row.media_url) + idx;

const useFocusableDiv = (offset = 160) => {
  const divRef = useRef<HTMLDivElement>();
  const focus = useCallback(
    () => divRef.current && scrollToElement(divRef.current, offset),
    [divRef, offset]
  );
  return { divRef, focus };
};

interface FormFieldProps {
  name: string;
  control: Control;
  [k: string]: any;
}

const createFormField =
  (
    InnerComponent: React.ComponentType<{ value: any; onChange: any, company_services: any, company_vtr_id: any }>,
    { defaultValue = null, passProps = false, company_services = [], company_vtr_id = null }: { defaultValue?: any; passProps?: boolean, company_services?: any, company_vtr_id?: any } = {}
  ) =>
    ({ name, control, company_services, ...otherProps }: FormFieldProps) => {
      const { divRef, focus: onFocus } = useFocusableDiv();
      const {
        field: { value, onChange },
      } = useController({ name, control, defaultValue, onFocus });
      const passingProps = passProps ? otherProps : {};
      return (
        <div ref={divRef}>
          <InnerComponent value={value} onChange={onChange} company_services={company_services} company_vtr_id={company_vtr_id} {...passingProps} />
        </div>
      );
    };
export const MediaField = createFormField(MediaLoader, {
  defaultValue: [],
  passProps: true,
  company_services: [],
  company_vtr_id: '',
});

const MediaContainer = styled.div`
  padding: 10px 5px;
  background: #f5f5f5;
  table {
    td:nth-of-type(1) {
      padding-left: 10px;
      width: 40px;
    }
    th:nth-of-type(1) {
      padding-left: 10px;
      width: 40px;
    }
    // td:nth-of-type(2) {
    //   width: 35px;
    // }
    td:last-child {
      width: 80px;
    }
  }
  .drag-icon {
    cursor: grab;
  }
  .fixed-height {
    ${thumbStack}
    margin-top: 6px;
    margin-bottom: 6px;
    height: 40vh;
    position: relative;
    overflow: auto;
    .MuiTableContainer-root {
      ${thumbStack}
      height: inherit;
      overflow: inherit;
    }
    &.no-data {
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        text-align: center;
        svg {
          font-size: 4em;
          color: #ccc;
        }
      }
    }
  }
`;
